export function focus(guid) {
    if (guid) {
        const input = document.getElementById(guid);
        if (input) {
            input.focus();
            input.select();
        }
    }
}
